/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Status_DraftInputs */

const en_statement_taxonomy_status_draft = /** @type {(inputs: Statement_Taxonomy_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const nl_statement_taxonomy_status_draft = /** @type {(inputs: Statement_Taxonomy_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concept`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Statement_Taxonomy_Status_DraftInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_status_draft = /** @type {((inputs?: Statement_Taxonomy_Status_DraftInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Status_DraftInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_status_draft(inputs)
	return en_statement_taxonomy_status_draft(inputs)
});